/* Progressive enhancements only. Shopify owns cart, variants and checkout. */
(() => {
  'use strict';
  document.addEventListener('click', (event) => {
    const play = event.target.closest('[data-dp-play]');
    if (play) {
      const frame = play.closest('[data-dp-video]');
      const id = frame?.dataset.dpVideo || '';
      if (!/^[\w-]{11}$/.test(id)) return;
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
      iframe.title = play.getAttribute('aria-label') || 'DriftParc video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.replaceChildren(iframe);
      iframe.focus();
    }
    document.querySelectorAll('[data-dp-menu][open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menus = [...document.querySelectorAll('[data-dp-menu][open]')];
    const focusedMenu = document.activeElement?.closest('[data-dp-menu][open]');
    const menu = focusedMenu || menus.at(-1);
    if (menu) {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    }
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('iframe[src*="youtube-nocookie.com"]').forEach(frame => frame.remove());
  });
})();
